import React,{useContext} from 'react'
import { GlobalContext } from '../../../context/provider';
import numberbeautify from '../../../utils/numberbeautify';
import money_rounding from '../../../utils/money_rounding';

const Most_broke_table = () => {
    const { initState } = useContext(GlobalContext);
    return (
        <div className="mt-6">
            {/* Category List Card */}
            <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
                
                {/* Section Header */}
                <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                <h2 className="text-base font-semibold text-slate-800">زۆرترین خەساربوو</h2>
                </div>

                {/* Table */}
                <table className="w-full">
                    <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                ناوی کاڵا
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                کۆد
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی خەسار
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                کۆی خەسار
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.most_broke_report.map((lis)=>(
                        <tr key={lis.item_id} className="hover:bg-slate-50 transition-colors duration-100">
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.item_name}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {lis.item_barcode}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {/* {lis.item_unit_one} {Math.floor(lis.total_qty_broke)}/{Math.round((Number(lis.total_qty_broke)-Number(Math.floor(lis.total_qty_broke)))*lis.item_unit_one_of_many)} {lis.item_unit_many}  */}
                                {lis.item_unit_one} {Math.floor(lis.item_qty/lis.item_unit_one_of_many)}/{money_rounding(Number(lis.item_qty) % lis.item_unit_one_of_many)} {lis.item_unit_many}
                            </td>
                            <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                {numberbeautify(money_rounding(lis.total_price_broke))} $
                            </td>
                        </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Most_broke_table